class Comingsoon extends HTMLElement {
  constructor() {
    super();
    this.time = this.dataset.time;
    this.timerEl = this.querySelector("#timer");
    this.productVariantSelector = document.querySelector(".product__info-wrapper variant-radios");
    this.productFrom = document.querySelector(".product__info-wrapper product-form");
    this.scripts = [...document.getElementsByTagName('script'),...document.getElementsByTagName('noscript')];
    this.rating = document.querySelector('.product__info-wrapper .ruk_rating_snippet');
    this.productId = document.querySelector('.product__info-wrapper input[name="id"]');

    this.renderTimer();
  }

  removeForm() {
    const completeTheLook = document.querySelector('.complete-the-look-wrapper');
    if (completeTheLook) completeTheLook.remove();
    if (this.productVariantSelector) this.productVariantSelector.remove();
    if (this.productFrom) this.productFrom.remove();
  }

  renderTimer() {
    if (!this.time || !this.timerEl) return;
    const countDownDate = new Date(this.time).getTime();
    const currentTime = new Date().getTime();
    const timeLeft = countDownDate - currentTime;

    if (timeLeft < 0) {
      this.remove();
      return;
    }

    this.removeForm();
    this.scripts.forEach((script) => {
      if (script.textContent.includes(this.productId.value)) script.remove();
    });
    this.rating.remove();
    this.productId.remove();

    this.style.display = "block";

    // Update the count down every 1 second
    var x = setInterval(() => {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Output the result in an element with id="demo"
      if (this.dataset.iso == 'de') {
          this.timerEl.innerHTML = `
              <span>${days}<b>Tage</b></span> : 
              <span>${hours}<b>Stunden</b></span> : 
              <span>${minutes}<b>Minuten</b></span> : 
              <span>${seconds}<b>Sekunden</b></span>`;
      } else {
          this.timerEl.innerHTML = `
              <span>${days}<b>Days</b></span> : 
              <span>${hours}<b>Hours</b></span> : 
              <span>${minutes}<b>Minutes</b></span> : 
              <span>${seconds}<b>Seconds</b></span>`;
      }
      // If the count down is over, write some text
      if (distance < 0) {
        clearInterval(x);
        this.remove();
      }
    }, 1000);
  }
}

customElements.define("coming-soon", Comingsoon);